import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import VerifyOtpPage from './pages/VerifyOtpPage';
import MyItinerariesPage from './pages/MyItinerariesPage';
import RoamSharePage from './pages/RoamSharePage';
import MyProfilePage from './pages/MyProfilePage';
import ItineraryPage from './pages/ItineraryPage';
import AccountInfoPage from './pages/AccountInfoPage';
import BucketListPage from './pages/BucketListPage';
import CreatePostPage from './pages/CreatePostPage';
import PublicProfilePage from './pages/PublicProfilePage';
import NotificationsPage from './pages/NotificationsPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SharedItineraryPage from './pages/SharedItineraryPage';
import HelpPage from './pages/HelpPage';
import AboutUsPage from './pages/AboutUsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import SupportPage from './pages/SupportPage';
import DeleteAccountPage from './pages/DeleteAccountPage';


function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/verify-otp" element={<VerifyOtpPage />} />
          <Route path="/itinerary" element={<ItineraryPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/itinerary/shared/:shareId" element={<SharedItineraryPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />

          
          {/* Protected Routes */}
          <Route path="/my-itineraries"  element={  <ProtectedRoute>  <MyItinerariesPage />  </ProtectedRoute>  }  />
          <Route  path="/roam-share"  element={  <ProtectedRoute> <RoamSharePage /> </ProtectedRoute>  } />
          <Route path="/profile" element={  <ProtectedRoute>  <MyProfilePage /> </ProtectedRoute> } />
          <Route  path="/account-info" element={  <ProtectedRoute>  <AccountInfoPage /> </ProtectedRoute> } />
          <Route path="/bucket-list"element={ <ProtectedRoute> <BucketListPage /> </ProtectedRoute>}/>
          <Route path="/create-post" element={ <ProtectedRoute>  <CreatePostPage /> </ProtectedRoute> } />
          <Route path="/u/:username" element={<ProtectedRoute><PublicProfilePage /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
          <Route path="/help" element={<ProtectedRoute><HelpPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute allowedRoles={['admin', 'super-admin']}><AdminDashboardPage /></ProtectedRoute>} />
          
        </Routes> 
      </Router>
    </AuthProvider>
  );
}

export default App;
